import request from '@/api/request.js'

// 新增
export function QuestionTypeInsert(data) {
    return request({
        url: '/api/question/questiontypeinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function QuestionTypeDelete(id) {
    return request({
        url: `/api/question/questiontypedelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function QuestionTypeUpdate(id, data) {
    return request({
        url: `/api/question/questiontypeupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function QuestionTypeGetById(id) {
    return request({
        url: `/api/question/getquestiontypebyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function QuestionTypeGetList(params) {
    return request({
        url: '/api/question/getquestiontypelist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function QuestionTypeGetPageList(params) {
    return request({
        url: '/api/question/getquestiontypepagelist',
        method: 'get',
        params: params
    })
}